$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
ApiAjax = require 'app/scripts/network/api-ajax'
Auth = require 'app/scripts/db/auth'
Board = require 'app/scripts/models/board'
Browser = require '@trello/browser'
ConfirmAddEmail = require 'app/scripts/views/header/confirm-add-email'
Dialog = require 'app/scripts/views/lib/dialog'
ModelLoader = require 'app/scripts/db/model-loader'
Util = require 'app/scripts/lib/util'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
_ = require 'underscore'
template = require 'app/scripts/views/templates/personalized_header_invite'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
{ Analytics, getScreenFromUrl } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class InvitedBannerView extends WarningBannerView
  events:
    'click .js-join-model': 'joinModel'
    'click .js-ignore-invite': 'ignoreInvite'
    'click .js-create-new-account': 'createNewAccount'

  className: ->
    colorMod = if !@options.idBoard? then 'mod-blue' else ''
    "header-banner mod-warning mod-invited personalized-invite #{colorMod}"

  initialize: ->
    @boardOrOrg =
      if @options.idBoard
        @modelCache.get('Board', @options.idBoard)
      else
        @modelCache.get('Organization', @options.idOrganization)

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)
    @eventContainers =
      if @options.idBoard
        { board: { id: @options.idBoard } }
      else
        { organization: { id: @options.idOrganization } }

    ModelLoader.loadMemberEmail @getGhost().id
    .then (member) =>
      if !(email = member.get('email'))?
        return
      ApiAjax
        url: '/1/search/members/'
        type: 'get'
        data: { query: email }
        dataType: 'json'
        success: (data) =>
          if !_.isEmpty(data) && data[0].memberType == 'normal'
            #looks like there's already an unconfirmed member with this email
            @hasAccount = true
    .finally =>
      @render()
    .done()

  getInviteToken: ->
    Util.inviteTokenFor(@boardOrOrg.id)

  getMemberAdder: ->
    idMemberAdder = @getInviteToken().split('-')[1]
    @modelCache.get('Member', idMemberAdder)

  getGhost: ->
    idMemberGhost = @getInviteToken().split('-')[0]
    @modelCache.get('Member', idMemberGhost)

  render: ->
    data = @model.toJSON()

    data.isLoggedIn = Auth.isLoggedIn()

    if @boardOrOrg instanceof Board
      data.isBoard = true
      data.modelName = @boardOrOrg.get 'name'
    else
      data.modelName = @boardOrOrg.get 'displayName'

    data.modelType = @boardOrOrg.typeName

    memberAdder = @getMemberAdder()
    if memberAdder?
      data.memberAdder = memberAdder.toJSON()
      data.isInviter = Auth.isMe(memberAdder)

    ghost = @getGhost()
    data.ghost = ghost?.toJSON()
    data.isGhostEmailLoggedIn = ghost?.get('email') == data.email
    data.signupUrl = "/signup?" + $.param
      reauthenticate: true
      returnUrl: "#{location.pathname}?completedInviteSignup=1" # Some routes have more redirect logic post-signup
      email: ghost?.get('email')
      fullName: ghost?.get('fullName')

    data.me = Auth.me()?.toJSON()
    data.isInternetExplorer = Browser.isIE() || Browser.isEdge()

    if @sendGASEvent
      Analytics.sendViewedBannerEvent
        bannerName: 'invitedBanner'
        source: getScreenFromUrl()
        containers: @eventContainers

    @$el.html template(data)

    @

  performModelJoin: ->
    type = if @options.idBoard then 'board' else 'organization'
    idModel = @options.idBoard ? @options.idOrganization
    ApiAjax
      url: "/associate-json/#{type}/#{idModel}/#{Util.inviteTokenFor(idModel)}"
      dataType: 'json'
      type: 'post'
      success: (data) =>
        if !data.error?
          @deleteTokenCookie()
          # Get us out of a state where are showing the member as a ghost
          window.location.reload()

  joinModel: (e) ->
    Util.stop(e)
    if Auth.isLoggedIn()
      ghostEmail = @getGhost().get('email')
      memberEmail = Auth.me().get('email')

      if ghostEmail == memberEmail
          @performModelJoin()
      else
        ConfirmAddEmail.toggle 'add email',
          elem: $(e.target)
          model: @model
          html: l('confirm.add email.text', { ghostEmail })
          data: @model.toJSON()
          fxConfirm: => @performModelJoin()

  deleteTokenCookie: ->
    $.cookie("invite-token-#{@options.idBoard ? @options.idOrganization}", null, path: '/')

  hideHeader: ->
    $(@el).hide()
    Util.calcBoardLayout()

  ignoreInvite: (e) ->
    Util.stop(e)
    if (ghost = @getGhost())?
      type = if @options.idBoard then 'board' else 'organization'
      idModel = @options.idBoard ? @options.idOrganization

      # Remove the member
      @boardOrOrg.memberList.removeMembership @getGhost(),
        invite: true

      # Assume the remove will succeed and immediately hide the header
      @hideHeader()
      @deleteTokenCookie()
      key = switch type
        when 'board' then 'rejected board invite'
        when 'organization' then 'rejected org invite'
      Alerts.show(key, 'error', null, 5000)

  createNewAccount: (e) ->
    track("Header", "Login/Signup Menu", "Open Login/Signup Menu: Create New")
    if @sendGASEvent
      Analytics.sendClickedButtonEvent
        buttonName: 'createNewAccountButton'
        source: 'invitedBanner'
        containers: @eventContainers
